var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiltersLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 2H1a1 1 0 010-2h16a1 1 0 010 2zm-4 4H5a1 1 0 010-2h8a1 1 0 010 2zm-3 3a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "#176DFF"
  })));
}
export default __webpack_public_path__ + "static/svg/filters-logo.svg";
export { SvgFiltersLogo as ReactComponent };